// ==================== HEADER ====================

function updateBodyPadding() {
    var headerHeight = $('.section-new-header').outerHeight() || 0;
    $('body').css('padding-top', headerHeight + 'px');
}

$(document).ready(function () {
    updateBodyPadding();
});

$(window).on('resize', function () {
    updateBodyPadding();
});




$(document).ready(function () {
    function moveTrancy() {
        const trancy = document.querySelector("#transcySwitcherContainer");
        const target = document.querySelector(".new-header-translate");

        if (trancy && target && !target.contains(trancy)) {
            target.appendChild(trancy);
            return true;
        }
        return false;
    }

    // Try immediately
    if (moveTrancy()) return;

    // If Trancy loads late, keep checking until it appears
    const observer = new MutationObserver(() => {
        if (moveTrancy()) observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });
});

$(document).ready(function () {
    function moveCart() {
        const cart = $('.header__icon--cart');
        const mobileTarget = $('.mobile-cart');
        const desktopTarget = $('.header-menu-1');
        const translateTarget = desktopTarget.find('.new-header-translate');

        if ($(window).width() <= 1400) {
            // MOBILE
            if (!mobileTarget.find('.header__icon--cart').length) {
                mobileTarget.append(cart);
            }
        } else {
            // DESKTOP
            if (translateTarget.length) {
                // Insert BEFORE .new-header-translate
                if (!desktopTarget.find('.header__icon--cart').length) {
                    cart.insertBefore(translateTarget);
                }
            } else {
                // Fallback: append to desktop target
                if (!desktopTarget.find('.header__icon--cart').length) {
                    desktopTarget.append(cart);
                }
            }
        }
    }

    // Run on load
    moveCart();

    // Run on resize
    $(window).on('resize', function () {
        moveCart();
    });
});



let couponBlurbSwiper = null;

function initCouponBlurb() {
    const isMobile = window.innerWidth <= 991;
    const container = document.querySelector('.coupon-blurb-container');

    if (!container) return; // safety check

    if (isMobile) {
        // INIT
        if (!couponBlurbSwiper) {
            couponBlurbSwiper = new Swiper(".coupon-blurb-container", {
                loop: true,
                autoplay: {
                    delay: 3000
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                    },
                    601: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                    }
                }
            });
        }
    } else {
        // DESTROY
        if (couponBlurbSwiper) {
            couponBlurbSwiper.destroy(true, true);
            couponBlurbSwiper = null;
        }
    }
}

document.addEventListener('DOMContentLoaded', initCouponBlurb);

// Debounced resize (prevents spam)
let resizeTimer;
window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initCouponBlurb, 150);
});

$(document).ready(function () {
    const $imgs = $('.dr-muppy img');
    let index = 0;

    setInterval(() => {
        const next = (index + 1) % $imgs.length;

        $imgs.eq(index).css('opacity', 0);
        $imgs.eq(next).css('opacity', 1);

        index = next;
    }, 2500);
});

// ==================== FOOTER ====================
// REUSABLE GET YEAR TODAY
var dateToday = new Date();
var yearToday = dateToday.getFullYear();
var websiteYear = document.getElementById('website-year');
websiteYear.innerHTML = yearToday;

// ==================== HOMEPAGE ====================
// ========== BANNER ==========
const swiperHomepage = new Swiper('.homepage-banner-slider', {
    loop: true,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    autoplay: {
        delay: 5000
    },
    pagination: {
        el: '.homepage-banner-pagination',
        clickable: true
    },
    navigation: {
        nextEl: '.custom-homepage-banner-slider .swiper-button-next.custom-slider-button-1',
        prevEl: '.custom-homepage-banner-slider .swiper-button-prev.custom-slider-button-1',
    },
    speed: 1000,
    effect: 'fade',
    fadeEffect: { crossFade: true }

});

$('.custom-slider-button-1.swiper-button-next').on('click', function (e) {
    e.preventDefault();

    if (swiperHomepage.animating) {
        swiperHomepage.animating = false;  // unlock animation lock
    }

    swiperHomepage.slideNext(); // normal slide with animation
});

$('.custom-slider-button-1.swiper-button-prev').on('click', function (e) {
    e.preventDefault();

    if (swiperHomepage.animating) {
        swiperHomepage.animating = false;  // unlock animation lock
    }

    swiperHomepage.slidePrev(); // normal slide with animation
});

$(document).on('click', '.sound-icon', function () {
    const video = $('.banner-video').get(0);

    if ($(this).hasClass('sound-off')) {
        // Unmute
        video.muted = false;

        // Switch icon state
        $(this).removeClass('sound-active').siblings().addClass('sound-active');
    }
    else if ($(this).hasClass('sound-on')) {
        // Mute
        video.muted = true;

        // Switch icon state
        $(this).removeClass('sound-active').siblings().addClass('sound-active');
    }
});

// JS fallback — place before </body> or in your theme.js
document.addEventListener('DOMContentLoaded', function () {
    const videos = document.querySelectorAll('video.banner-video');
    videos.forEach(function (video) {
        video.muted = true; // must be set via JS too for some iOS versions
        const playPromise = video.play();
        if (playPromise !== undefined) {
            playPromise.catch(function () {
                // Autoplay blocked — try on first user interaction
                document.addEventListener('touchstart', function () {
                    video.play();
                }, { once: true });
            });
        }

        // Click to play/pause
        video.addEventListener('click', function () {
            if (video.paused) {
                video.play().catch(function () { });
            } else {
                video.pause();
            }
        });
    });
});


// ========== BEST SELLER SLIDER ==========

let bestsellerSwiper = null;

$(document).ready(function () {
    function initBestsellerSwiper() {
        if (window.bestellerSwiper) {
            window.bestellerSwiper.destroy(true, true);
        }

        window.bestellerSwiper = new Swiper(".custom-product-slider", {
            loop: false,
            slidesPerView: 4,
            spaceBetween: 20,

            grid: {
                // rows: 2,
                // fill: "row"
            },

            // pagination: {
            //     el: ".swiper-pagination",
            //     clickable: true
            // },

            pagination: {
                el: '.best-seller-pagination',
                clickable: true
            },

            navigation: {
                nextEl: '.custom-product-slider-nav-1 .swiper-button-next.custom-slider-button-1',
                prevEl: '.custom-product-slider-nav-1 .swiper-button-prev.custom-slider-button-1',
            },

            breakpoints: {
                320: {
                    slidesPerView: 2,
                    // grid: { rows: 2 },
                    spaceBetween: 10,
                },
                768: {
                    slidesPerView: 3,
                    // grid: { rows: 2 },
                    spaceBetween: 15,
                },
                991: {
                    slidesPerView: 5,
                    // grid: { rows: 2 },
                    spaceBetween: 15,
                }
            }
        });
        customProductContent();
    }
    $(document).ready(initBestsellerSwiper);

});

$(document).ready(function () {

    // Price filter functionality
    function filterProducts() {
        var minPriceInput = $('#Custom-Preis-GTE').val().trim();
        var maxPriceInput = $('#Custom-Preis-LTE').val().trim();

        var minPrice = minPriceInput ? parseFloat(minPriceInput.replace(',', '.')) : 0;
        var maxPrice = maxPriceInput ? parseFloat(maxPriceInput.replace(',', '.')) : 999999;

        console.log('Filter - Min:', minPrice, 'Max:', maxPrice);

        var visibleCount = 0;

        $('.custom-product-slider .custom-product-item').each(function () {
            var priceData = $(this).data('price') || $(this).attr('data-price');
            var productPrice = parseFloat(priceData);

            if (isNaN(productPrice)) {
                return;
            }

            var $slide = $(this).closest('.custom-product-slider .swiper-slide');

            // Show/hide based on price range
            if (productPrice >= minPrice && productPrice <= maxPrice) {
                $slide.removeClass('filtered-out').show();
                visibleCount++;
                console.log('✓ Showing:', productPrice);
            } else {
                $slide.addClass('filtered-out').hide();
                console.log('✗ Hiding:', productPrice);
            }
        });

        // Update Swiper to recalculate slides
        if (window.bestellerSwiper) {
            // Force update multiple times to ensure grid recalculates
            window.bestellerSwiper.update();

            setTimeout(function () {
                customProductContent();
                window.bestellerSwiper.updateSlides();
                window.bestellerSwiper.updateProgress();
                window.bestellerSwiper.updateSlidesClasses();

                // If very few slides, disable loop
                if (visibleCount <= 4) {
                    window.bestellerSwiper.params.loop = false;
                }

                window.bestellerSwiper.update();

            }, 10);
        }

        console.log('Total visible:', visibleCount);
        customProductContent();
    }

    // Trigger filter on input
    $('#Custom-Preis-GTE, #Custom-Preis-LTE').on('input', function () {
        filterProducts();
    });

    // Reset filter
    $('.filter-reset').on('click', function (e) {
        e.preventDefault();
        $('#Custom-Preis-GTE').val('');
        $('#Custom-Preis-LTE').val('');

        $('.custom-product-slider .custom-product-item').removeClass('filtered-out');
        $('.custom-product-slider .swiper-slide').show();

        // Update Swiper after reset
        if (window.bestellerSwiper) {
            window.bestellerSwiper.update();
            window.bestellerSwiper.updateSlides();
            window.bestellerSwiper.updateProgress();
            window.bestellerSwiper.updateSlidesClasses();
            customProductContent();
        }
    });

    // Optional: Toggle coming soon products
    // Add this if you want to filter out coming soon items
    $('#hide-coming-soon').on('change', function () {
        if ($(this).is(':checked')) {
            $('.custom-product-slider .custom-product-item').each(function () {
                if ($(this).find('.custom-coming-soon').length > 0) {
                    $(this).addClass('filtered-out');
                    $(this).parent().hide();
                }
            });
        } else {
            $('.custom-product-slider .custom-product-item').each(function () {
                if ($(this).find('.custom-coming-soon').length > 0) {
                    $(this).removeClass('filtered-out');
                    $(this).parent().show();
                }
            });
            filterProducts(); // Reapply price filter
        }

        // Update Swiper
        if (window.bestellerSwiper) {
            window.bestellerSwiper.update();
            window.bestellerSwiper.updateSlides();
            window.bestellerSwiper.updateProgress();
            window.bestellerSwiper.updateSlidesClasses();
        }
    });

});

$(document).ready(function () {

    // Price filter functionality
    function filterProducts() {
        var minPrice = parseFloat($('#Custom-Preis-GTE').val().replace(',', '.')) || 0;
        var maxPrice = parseFloat($('#Custom-Preis-LTE').val().replace(',', '.')) || 999999;

        $('.custom-product-slider .custom-product-item').each(function () {
            var productPrice = parseFloat($(this).data('price'));
            var isAvailable = $(this).data('available');
            var isComingSoon = $(this).find('.custom-coming-soon').length > 0;

            // Show/hide based on price range
            if (productPrice >= minPrice && productPrice <= maxPrice) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });

        // Update Swiper after filtering
        if (typeof productSlider !== 'undefined') {
            productSlider.update();
        }
    }

    // Trigger filter on input change
    $('#Custom-Preis-GTE, #Custom-Preis-LTE').on('input change', function () {
        filterProducts();
    });

    // Reset filter
    $('.filter-reset').on('click', function (e) {
        e.preventDefault();
        $('#Custom-Preis-GTE').val('');
        $('#Custom-Preis-LTE').val('');
        $('.custom-product-slider .custom-product-item').show();

        // Update Swiper after reset
        if (typeof productSlider !== 'undefined') {
            productSlider.update();
        }
    });

    // Optional: Hide coming soon products by default
    // Uncomment if you want to hide them on page load
    /*
    $('.custom-product-slider .custom-product-item').each(function() {
      if ($(this).find('.custom-coming-soon').length > 0) {
        $(this).hide();
      }
    });
    */

    customProductContent();
});


function customProductContent() {
    //COPY MAX HEIGHT
    $(".custom-product-content").css("height", "auto");
    var maxHeight = 0;
    $(".custom-product-content").each(function () {
        var height = $(this).outerHeight();
        if (height > maxHeight) {
            maxHeight = height;
        }
    });
    // Set the maximum height to all divs
    $(".custom-product-content").css("height", maxHeight + "px");
}
customProductContent();
$(window).resize(function () {
    customProductContent();
});



// OPEN / CLOSE DROPDOWN
$('.dropdown-toggle').on('click', function (e) {
    e.stopPropagation(); // prevent immediate close

    const $current = $(this).closest('.dropdown-filter');

    // Close all others
    $('.dropdown-filter.open').not($current).removeClass('open');

    // Toggle current
    $current.toggleClass('open');
});

// CLOSE WHEN CLICKING OUTSIDE
$(document).on('click', function () {
    $('.dropdown-filter.open').removeClass('open');
});

// PREVENT CLOSING WHEN CLICKING INSIDE CONTENT
$('.dropdown-content').on('click', function (e) {
    e.stopPropagation();
});

$('.product-sort-filter').on('click', function (e) {
    $(this).toggleClass('open');
});

// FORCE DEFAULT CHECKED
$('input[name="availability[]"][value="in"]').prop('checked', true);

const $form = $('.custom-filter-bar');
const $grid = $('#all-products-grid');

$('.price-container .field:nth-child(1) input').attr('placeholder', 'Von');

$('.price-container .field:nth-child(2) input').attr('placeholder', 'Bis');

// Remove all URL parameters on load
if (window.location.search.length > 0) {
    window.history.replaceState({}, document.title, window.location.pathname);
}

// Reset all filter inputs
$('.custom-filter-bar input[type="text"]').val('');
$('.custom-filter-bar select[name="sort_by"]').prop('selectedIndex', 0);

// Reset filter - updated to reset ALL filters
$('.section-bestseller-filter .filter-reset').on('click', function (e) {
    e.preventDefault();

    // Reset price inputs
    $('#Custom-Preis-GTE').val('');
    $('#Custom-Preis-LTE').val('');

    // Reset coming soon checkbox if it exists
    $('#hide-coming-soon').prop('checked', false);

    // Show all products
    $('.custom-product-slider .custom-product-item').removeClass('filtered-out');
    $('.custom-product-slider .swiper-slide').show();

    // Reset any other filters you might have
    // Add more reset logic here if you have other filters

    // Update Swiper after reset
    if (window.bestellerSwiper) {
        window.bestellerSwiper.update();
        window.bestellerSwiper.updateSlides();
        window.bestellerSwiper.updateProgress();
        window.bestellerSwiper.updateSlidesClasses();
    }

    //   console.log('All filters reset');
});




window.newArrivalsSwiper = new Swiper(".custom-product-slider-2", {
    loop: false,

    pagination: {
        el: '.new-arrivals-pagination',
        clickable: true
    },

    navigation: {
        nextEl: '.custom-product-slider-nav-2 .swiper-button-next.custom-slider-button-1',
        prevEl: '.custom-product-slider-nav-2 .swiper-button-prev.custom-slider-button-1',
    },

    breakpoints: {
        320: {
            slidesPerView: 2,
            spaceBetween: 10,
        },
        768: {
            slidesPerView: 3,
            spaceBetween: 15,
        },
        991: {
            slidesPerView: 5,
            spaceBetween: 15,
        }
    }
});

let fitnessSwiper = null;

function initFitnessSwiper() {
    if (window.innerWidth <= 991) {
        if (!fitnessSwiper) {
            fitnessSwiper = new Swiper('.custom-product-slider-3', {
                pagination: {
                    el: '.fitness-pagination',
                    clickable: true
                },

                navigation: {
                    nextEl: '.custom-product-slider-nav-3 .swiper-button-next.custom-slider-button-1',
                    prevEl: '.custom-product-slider-nav-3 .swiper-button-prev.custom-slider-button-1',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 15,
                    },
                    991: {
                        slidesPerView: 5,
                        spaceBetween: 15,
                    }
                }
            });
        }
    } else {
        if (fitnessSwiper) {
            fitnessSwiper.destroy(true, true);
            fitnessSwiper = null;
        }
    }
}

document.addEventListener('DOMContentLoaded', initFitnessSwiper);
window.addEventListener('resize', initFitnessSwiper);



// ========== STORIES ==========
// const swiper = new Swiper('.stories-container', {
//     on: {
//         slideChange: function () {
//             const activeSlide = this.slides[this.activeIndex];
//             const video = activeSlide.querySelector('video');

//             if (video && !video.src) {
//                 video.src = video.dataset.src;
//             }
//         }
//     }
// });


// $(document).ready(function () {

//     if (window.storiesSwiper) {
//         window.storiesSwiper.destroy(true, true);
//     }

//     window.storiesSwiper = new Swiper(".stories-container", {
        
//         loop: false,
//         slidesPerView: 4,
//         spaceBetween: 20,
//         slidesPerGroup: 1,

//         grid: {
//             rows: 1,
//             fill: "row"
//         },

//         navigation: {
//             nextEl: '.custom-stories-nav-1 .swiper-button-next.custom-slider-button-1',
//             prevEl: '.custom-stories-nav-1 .swiper-button-prev.custom-slider-button-1',
//         },

//         breakpoints: {
//             320: {
//                 slidesPerView: 2,
//                 grid: { rows: 1 }
//             },
//             768: {
//                 slidesPerView: 3,
//                 grid: { rows: 1 }
//             },
//             992: {
//                 slidesPerView: 4,
//                 grid: { rows: 1 }
//             },
//             1301: {
//                 slidesPerView: 6,
//                 grid: { rows: 1 }
//             }

//         }
//     });
// });

$(document).ready(function () {

    if (window.storiesSwiper) {
        window.storiesSwiper.destroy(true, true);
    }

    window.storiesSwiper = new Swiper(".stories-container", {

        loop: false,
        slidesPerView: 4,
        spaceBetween: 20,
        // slidesPerGroup: 1,

        grid: {
            rows: 1,
            fill: "row"
        },

        navigation: {
            nextEl: '.custom-stories-nav-1 .swiper-button-next.custom-slider-button-1',
            prevEl: '.custom-stories-nav-1 .swiper-button-prev.custom-slider-button-1',
        },

        breakpoints: {
            320: {
                slidesPerView: 2,
                grid: { rows: 1 }
            },
            768: {
                slidesPerView: 3,
                grid: { rows: 1 }
            },
            992: {
                slidesPerView: 4,
                grid: { rows: 1 }
            },
            1301: {
                slidesPerView: 6,
                grid: { rows: 1 }
            }
        },

        // ⭐ ADDING THE VIDEO LAZY-LOAD LOGIC HERE
        on: {
            slideChange: function () {
                const activeSlide = this.slides[this.activeIndex];
                const video = activeSlide.querySelector('video');

                if (video && !video.src) {
                    video.src = video.dataset.src;
                }
            }
        }
    });
});



$('.stories-box').on('click', function () {
    const currentBox = $(this);
    const currentVideo = currentBox.find('video').get(0);

    // Pause all other videos
    $('.stories-box').not(currentBox).each(function () {
        const otherVideo = $(this).find('video').get(0);
        if (otherVideo && !otherVideo.paused) {
            otherVideo.pause();
            $(this).removeClass('is-playing');
        }
    });

    // Toggle play/pause for the clicked one
    if (currentVideo.paused) {
        currentVideo.play();
        currentBox.addClass('is-playing');
    } else {
        currentVideo.pause();
        currentBox.removeClass('is-playing');
    }
});

// ========== IG FEED ==========
$('#shopify-section-template--15850886561840__17727758622f2ad57a')
    .appendTo('.row-ig-gallery');

// ========== MODELS ==========
$(document).ready(function () {

    if (window.modelSwiper) {
        window.modelSwiper.destroy(true, true);
    }

    window.modelSwiper = new Swiper(".model-slider", {
        loop: false,
        slidesPerView: 4.5,
        spaceBetween: 20,

        grid: {
            rows: 1,
            fill: "row"
        },

        pagination: {
            el: '.model-pagination',
            clickable: true
        },

        navigation: {
            nextEl: '.model-slider-nav .swiper-button-next.custom-slider-button-1',
            prevEl: '.model-slider-nav .swiper-button-prev.custom-slider-button-1',
        },

        breakpoints: {
            320: {
                slidesPerView: 2,
                grid: { rows: 1 }
            },
            768: {
                slidesPerView: 3,
                grid: { rows: 1 }
            },
            992: {
                slidesPerView: 5,
                grid: { rows: 1 }
            }
        }
    });
});



// ========== ADD TO CART ==========
window.addToCartFromCollection = function (button, variantId) {
    console.log('Adding variant to cart:', variantId);

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    const formData = new FormData();

    // Read selling plan from the hidden input updated by jQuery
    // Read selling plan for THIS product only (by handle)
    const handle = button.dataset.handle;

    // 1) Prefer checked (if radios), else .val() (if hidden/select)
    const $plans = $(`.seal-widget[data-handle="${handle}"] input[name="selling_plan"]`);
    const selectedPlan = $plans.filter(':checked').val() || $plans.val();

    if (selectedPlan) {
        formData.append('selling_plan', selectedPlan);
    }

    formData.append('id', variantId);

    const qtySelect = document.querySelector('.custom-add-cart .qty-dropdown');
    const qty = qtySelect ? parseInt(qtySelect.value, 10) : 1;
    formData.append('quantity', qty);


    fetch('/cart/add.js', {
        method: 'POST',
        body: formData
    })
        .then(response => response.json())
        .then(data => {
            console.log('Cart add response:', data);

            if (data.status === 422 || data.message || data.description) {
                console.error('Error adding to cart:', data);
                button.disabled = false;
                button.textContent = originalText;
                return null;
            }

            console.log('Product added successfully');

            return fetch('/cart.js');
        })
        .then(response => {
            if (!response) return null;
            return response.json();
        })
        .then(cartData => {
            if (!cartData) return null;

            const cartIcon = document.querySelector('#cart-icon-bubble');
            let cartBubble = cartIcon.querySelector('.cart-count-bubble');

            if (cartData.item_count > 0) {
                if (!cartBubble) {
                    cartBubble = document.createElement('div');
                    cartBubble.className = 'cart-count-bubble';
                    cartIcon.appendChild(cartBubble);
                }

                cartBubble.innerHTML = `
                    <span aria-hidden="true">${cartData.item_count}</span>
                    <span class="visually-hidden">${cartData.item_count} Artikel</span>
                `;
            }

            return fetch('/?section_id=cart-drawer');
        })
        .then(response => {
            if (!response) return null;
            return response.text();
        })
        .then(html => {
            if (!html) return;

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const cartDrawer = document.querySelector('cart-drawer');

            const newItems = doc.querySelector('cart-drawer-items');
            const currentItems = document.querySelector('cart-drawer-items');
            if (newItems && currentItems) {
                currentItems.outerHTML = newItems.outerHTML;
            }

            const newFooter = doc.querySelector('.drawer__footer');
            const currentFooter = document.querySelector('.drawer__footer');
            if (newFooter && currentFooter) {
                currentFooter.innerHTML = newFooter.innerHTML;
            }

            cartDrawer.classList.remove('is-empty');
            const drawerItems = document.querySelector('cart-drawer-items');
            if (drawerItems) {
                drawerItems.classList.remove('is-empty');
            }

            console.log('Opening cart drawer');
            cartDrawer.open();

            button.disabled = false;
            button.textContent = 'Added!';

            setTimeout(() => {
                button.textContent = originalText;
            }, 2000);
        })
        .catch(error => {
            console.error('Fetch error:', error);
            button.disabled = false;
            button.textContent = originalText;
        });
};




// ===== PRODUCT PAGE =====
// ==================== SHOP PAGE ====================
// ===== PRODUCT CARD =====
function productContent() {
    //COPY MAX HEIGHT
    $(".custom-product-content").css("height", "auto");
    var maxHeight = 0;
    $(".custom-product-content").each(function () {
        var height = $(this).outerHeight();
        if (height > maxHeight) {
            maxHeight = height;
        }
    });
    // Set the maximum height to all divs
    $(".custom-product-content").css("height", maxHeight + "px");
}
productContent();
$(window).resize(function () {
    productContent();
});


$(document).on('ajaxComplete', function () {
    // console.log("AJAX finished loading products");
    productContent();
});



// function customProductDesc() {
//     //COPY MAX HEIGHT
//     $(".custom-product-title").css("height", "auto");
//     var maxHeight = 0;
//     $(".custom-product-title").each(function () {
//         var height = $(this).outerHeight();
//         if (height > maxHeight) {
//             maxHeight = height;
//         }
//     });
//     // Set the maximum height to all divs
//     $(".custom-product-title").css("height", maxHeight + "px");
// }
// customProductDesc();
// $(window).resize(function () {
//     customProductDesc();
// });

// ===== PRODUCT PAGE =====
let companySwiper = null;

function initCompanySwiper() {
    if (window.innerWidth <= 1100) {
        if (!companySwiper) {
            companySwiper = new Swiper('.product-company-swiper', {
                slidesPerView: 6,
                spaceBetween: 20,
                loop: true,
                autoplay: {
                    delay: 2500,
                },
            });
        }
    } else {
        if (companySwiper) {
            companySwiper.destroy(true, true);
            companySwiper = null;
        }
    }
}

document.addEventListener('DOMContentLoaded', initCompanySwiper);
window.addEventListener('resize', initCompanySwiper);




jQuery(function ($) {
    const $customDropdowns = $('.custom-dropdown');
    const $mainDropdown = $('#bundleDropdown');
    let isSyncing = false; // Prevent infinite loops

    // Initialize each custom dropdown
    $customDropdowns.each(function () {
        const $customDropdown = $(this);
        const $trigger = $customDropdown.find('.custom-dropdown-trigger');
        const $options = $customDropdown.find('.custom-dropdown-option');
        const $selectedDisplay = $customDropdown.find('.custom-dropdown-selected');
        const $doneButton = $customDropdown.find('.custom-dropdown-done');

        // Toggle dropdown
        $trigger.on('click', function (e) {
            e.stopPropagation();

            const isOpen = $customDropdown.hasClass('open');

            // Close all dropdowns first
            $customDropdowns.removeClass('open');

            // Toggle this dropdown
            if (!isOpen) {
                $customDropdown.addClass('open');
            }
        });

        // Handle option selection
        $options.on('click', function (e) {
            if (isSyncing) return; // Skip if already syncing

            const $option = $(this);
            const $radio = $option.find('input[type="radio"]');
            const $label = $option.find('label');

            // Check radio if clicking anywhere in the option
            if (!$(e.target).is('input') && !$(e.target).is('label')) {
                $radio.prop('checked', true);
            }

            // Get the value
            const selectedValue = $option.attr('data-value');
            const selectedText = $label.text();

            // Update ALL custom dropdowns
            syncAllDropdowns(selectedValue, selectedText);

            // Update main dropdown
            $mainDropdown.val(selectedValue).trigger('change');

            // Close dropdown immediately
            $customDropdown.removeClass('open');
        });

        // Done button
        $doneButton.on('click', function (e) {
            e.stopPropagation();
            $customDropdown.removeClass('open');
        });
    });

    // Optimized sync function
    function syncAllDropdowns(value, text) {
        isSyncing = true;

        // Update all dropdowns in one pass
        $customDropdowns.each(function () {
            const $dropdown = $(this);

            // Update display
            $dropdown.find('.custom-dropdown-selected').text(text);

            // Update options
            const $opts = $dropdown.find('.custom-dropdown-option');
            $opts.removeClass('active');

            $opts.filter('[data-value="' + value + '"]')
                .addClass('active')
                .find('input[type="radio"]')
                .prop('checked', true);
        });

        // Small delay to prevent rapid firing
        setTimeout(function () {
            isSyncing = false;
        }, 50);
    }

    // Close on outside click (optimized)
    let clickTimeout;
    $(document).on('click', function (e) {
        clearTimeout(clickTimeout);
        clickTimeout = setTimeout(function () {
            if (!$(e.target).closest('.custom-dropdown').length) {
                $customDropdowns.removeClass('open');
            }
        }, 10);
    });

    // Sync when main dropdown changes
    $mainDropdown.on('change', function () {
        if (isSyncing) return;

        const selectedValue = $(this).val();
        const selectedText = $(this).find('option:selected').text();
        syncAllDropdowns(selectedValue, selectedText);
    });
});


jQuery(function ($) {

    function waitForSeal() {
        const checkInterval = setInterval(function () {
            // Check if Seal widget elements exist and are rendered
            const sealContainer = $('.sealsubs-container');
            const sealOptions = $('.sls-option-container');

            if (sealContainer.length > 0 && sealOptions.length > 0) {
                // console.log('✅ Seal Subscriptions widget is fully loaded!');
                // console.log('Number of widgets:', sealContainer.length);
                // console.log('Number of options:', sealOptions.length);

                $(".custom-product-subscription").removeClass("d-none");

                $(".product-subscription-loading").hide();

                setTimeout(doAfterLoad, 500);
                function doAfterLoad() {
                    $('.share-text').removeClass('d-none');
                }
                clearInterval(checkInterval);

                // Your code here - do something after Seal loads
                // Example: initialize your custom dropdown

            }
        }, 100); // Check every 100ms

        // Timeout after 10 seconds
        setTimeout(function () {
            clearInterval(checkInterval);
            console.log('⚠️ Seal Subscriptions check timeout');
        }, 10000);
    }

    waitForSeal();
});



function enforceNoTranslateRemoval(selector) {
    const elements = document.querySelectorAll(selector);
    if (!elements.length) return;

    elements.forEach((el) => {
        // Remove immediately if present
        if (el.classList.contains('notranslate')) {
            el.classList.remove('notranslate');
        }

        const observer = new MutationObserver(() => {
            // If class appears → remove it
            if (el.classList.contains('notranslate')) {
                el.classList.remove('notranslate');
            }

            // If class is gone → stop observing
            if (!el.classList.contains('notranslate')) {
                observer.disconnect();
                // Restart watcher in case class is added again later
                setTimeout(() => enforceNoTranslateRemoval(selector), 50);
            }
        });

        observer.observe(el, {
            attributes: true,
            attributeFilter: ['class']
        });
    });
}

// Apply to all elements
enforceNoTranslateRemoval('.coupon-blurb-text');
enforceNoTranslateRemoval('.col-coupon-blurb-1 h5');
enforceNoTranslateRemoval('.highest-price p');



$('.share-text').on('click', function () {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'UESq2T']);
});


$(document).ready(function () {
    $(document).on('click', '.jdgm-write-review-modal__nav-btn-close', function () {
        setTimeout(function () {
            $(".feedback-popup-overlay").addClass("feedback-popup-active");

            setTimeout(doAfterLoad, 100);
            function doAfterLoad() {
                $(".feedback-popup").addClass("op-1");
            }
        }, 500); // 3000 milliseconds = 3 seconds
    });
    $(".close-feedback-popup").click(function () {
        $(".feedback-popup").removeClass("op-1");
        setTimeout(doAfterLoad, 250);
        function doAfterLoad() {
            $(".feedback-popup-overlay").removeClass("feedback-popup-active");
        }
    });
});

$(document).on('click', '.feedback-code', function () {
    const code = $(this).text().trim();

    // Copy to clipboard
    navigator.clipboard.writeText(code).then(() => {
        // Show "COPIED CODE"
        $('.feedback-copied').removeClass('d-none');

        // Optional: hide again after 2 seconds
        setTimeout(() => {
            $('.feedback-copied').addClass('d-none');
        }, 2000);
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const path = window.location.pathname;

    // true if NOT English
    const isNotEnglish = !/^\/en(\/|$)/.test(path);

    if (isNotEnglish) {
        document.body.classList.add('not-english');
    }
});








$(document).ready(function () {
    $(document).on('click', '.share-text', function () {

        $(".refer-popup-overlay").addClass("refer-popup-active");

        setTimeout(doAfterLoad, 100);
        function doAfterLoad() {
            $(".refer-popup").addClass("op-1");
        }

    });
    $(".close-refer-popup").click(function () {
        $(".refer-popup").removeClass("op-1");
        setTimeout(doAfterLoad, 250);
        function doAfterLoad() {
            $(".refer-popup-overlay").removeClass("refer-popup-active");
        }
    });
});



$(document).ready(function () {
    const container = document.querySelector('.refer-step-1');
    if (!container) return;

    const observer = new MutationObserver(function () {
        // Look for ANY element that contains the success banner wrapper
        const successBanner = $('.refer-step-1').find('section[data-testid="banner-success"]');

        if (successBanner.length > 0) {
            console.log("SUCCESS DETECTED inside .refer-step-1");

            // Your custom actions here
            $(".share-text").removeClass("d-none");

            // $(".refer-step-1").append(`
            //     <div class="close-refer-popup">
            //         <h5>NO, THANKS</h5>
            //     </div>
            // `);

            observer.disconnect();
        }
    });

    observer.observe(container, { childList: true, subtree: true });
});




// $(document).ready(function () {
//     const embed = document.querySelector('#app-embed');
//     const shadow = embed?.shadowRoot;

//     if (shadow) {
//         const btn = shadow.querySelector('._formSubmitButton_cit2d_96');

//         if (btn) {
//             btn.click();
//             console.log("Clicked the shadow DOM submit button");
//         } else {
//             console.log("Button not found inside shadow DOM");
//         }



//         const style = document.createElement('style');
//         style.textContent = `
//         /* Your custom styles inside the shadow DOM */

//         /* Example: hide success step */
//         [data-current-step="success"] {
//             display: none !important;
//         }

//         /* Example: style the submit button */
//         ._formSubmitButton_cit2d_96 {
//             background: #ec008c !important;
//             color: #fff !important;
//             border-radius: 6px !important;
//             padding: 12px 20px !important;
//             font-size: 16px !important;
//         }

//         /* Add anything you want here */

//         ._formInputField_nag3b_7 {
//             padding: 1em !important;
//         }

//         ._formInputFieldLabel_1mxsl_38 {
//             top: 50% !important;
//             transform: translate(0%,-50%) !important;
//             left: 5% !important;
//         }

//         ._formFieldContainer_1mxsl_5 ._inputFilled_1mxsl_74 {
//             opacity: 0;
//         }

//         ._formSubmitButton_cit2d_96 {
//             font-family: "Avenir", sans-serif !important;
//             font-size: clamp(1.4rem, 2vw, 1.8rem) !important;
//             font-weight:800 !important
//         }
//     `;
//         shadow.appendChild(style);

//     }
// });

$(document).ready(function () {
    let attempts = 0;
    const maxAttempts = 200; // 20s safety cap

    const interval = setInterval(() => {
        attempts++;

        const embed = document.querySelector('#app-embed');
        if (!embed) {
            if (attempts >= maxAttempts) clearInterval(interval);
            return;
        }

        const shadow = embed.shadowRoot;
        if (!shadow) {
            if (attempts >= maxAttempts) clearInterval(interval);
            return;
        }

        // jQuery INSIDE the shadow root
        const $container = $(shadow).find('._formFieldContainer_1mxsl_5');

        if ($container.length) {
            $container.prepend('<h5>Email</h5>');

            const style = document.createElement('style');
            style.textContent = `
                ._formInputFieldLabel_1mxsl_38 {
                    display: none !important;
                }

                ._formFieldContainer_1mxsl_5 h5 {
                    margin:0 0 .5em !important;
                        font-family: "Avenir", sans-serif !important;
                        font-size: clamp(1rem, 1.6vw, 1.3rem) !important;
                        font-weight:400 !important;
                }

                ._formInputField_nag3b_7 {
                    padding:1em 1em .95em 1em !important;
                }
            `;
            shadow.appendChild(style);

            console.log('Injected heading + CSS into Shopify Forms shadow DOM');

            clearInterval(interval);
        }

        if (attempts >= maxAttempts) {
            clearInterval(interval);
        }
    }, 100);
});


$(function () {
    const isEnglish = /^\/en(\/|$)/.test(window.location.pathname);

    function swapToEnglish(defaultSelector, englishSelector) {
        const def = $(defaultSelector);
        const eng = $(englishSelector);

        if (!def.length && !eng.length) return;

        // Remove inline display:none
        def.css('display', '');
        eng.css('display', '');

        if (!isEnglish) {
            eng.hide();
            def.show();
            return;
        }

        // English page logic
        if (eng.text().trim().length > 0) {
            def.hide();
            eng.show();
        } else {
            eng.hide();
            def.show();
        }
    }

    // Description
    swapToEnglish('.catch-default', '.catch-eng');

    // Header
    swapToEnglish('.catch-header-default', '.catch-header-eng');

    // Coupon blurb — FIXED selector
    swapToEnglish(
        '.coupon-blurb-content.custom-eng .coupon-blurb-text',
        '.coupon-blurb-content.custom-eng .coupon-blurb-text-eng'
    );
    // Description
    swapToEnglish('.newsletter-step-1-text', '.newsletter-step-1-text-eng');
    swapToEnglish('.refer-step-1-text', '.refer-step-1-text-eng');
    swapToEnglish('.login-default', '.login-eng');

    swapToEnglish('.search-header', '.search-header-eng');

    swapToEnglish('.terms-cond', '.terms-cond-eng');

    $(".search-header").removeClass("op-0");
    $(".search-header-eng").removeClass("op-0");

    // $(document).on('click', '.ecomsend__Popover__Widget__left', function () {

    //     setTimeout(function () {

    //         const popupHTML = `
    //   <div class="newsletter-popup">
    //     <div class="newsletter-popup-step newsletter-step-1">
    //       <h2 class="newsletter-step-1-text">ENTSPERRE 5% RABATT</h2>
    //       <h2 class="newsletter-step-1-text-eng">UNLOCK 5% OFF</h2>
    //       <h5>
    //         Melde dich an, um 5% auf deine erste Bestellung und exklusiven Zugang zu unseren besten Angeboten zu erhalten.
    //       </h5>
    //       <input class="newsletter-custom-email" type="email" placeholder="Email">
    //       <h4 class="newsletter-agree">SIGN UP</h4>
    //       <h4 class="newsletter-disagree">NEIN, DANKE</h4>
    //     </div>

    //     <div class="newsletter-popup-step newsletter-step-2 d-none">
    //       <h2>Vielen Dank für deine Anmeldung!</h2>
    //       <h4>Du kannst diesen Rabattcode jetzt für 5% verwenden</h4>
    //       <h4 class="newsletter-code">IBSignUp5</h4>
    //       <h5 class="newsletter-copied d-none">CODE KOPIERT</h5>
    //       <div class="close-newsletter-popup">
    //         <h5>CLOSE</h5>
    //       </div>
    //     </div>
    //   </div>
    // `;

    //         $('.ecomsend__Modal__DescriptionText')
    //             .empty()
    //             .append(popupHTML);



    //     }, 1); // 500ms delay

    // });


    function injectNewsletterPopup() {
        setTimeout(function () {

            const popupHTML = `
            <div class="newsletter-popup">
                <div class="newsletter-popup-step newsletter-step-1">
                <h2 class="newsletter-step-1-text">ENTSPERRE 5% RABATT</h2>
                <h2 class="newsletter-step-1-text-eng">UNLOCK 5% OFF</h2>
                <h5>
                    Melde dich an, um 5% auf deine erste Bestellung und exklusiven Zugang zu unseren besten Angeboten zu erhalten.
                </h5>

                </div>

                <div class="newsletter-popup-step newsletter-step-2 d-none">
                <h2>Vielen Dank für deine Anmeldung!</h2>
                <h4>Du kannst diesen Rabattcode jetzt für 5% verwenden</h4>
                <h4 class="newsletter-code">IBSignUp5</h4>
                <h5 class="newsletter-copied d-none">CODE KOPIERT</h5>
                <div class="close-newsletter-popup">
                    <h5>CLOSE</h5>
                </div>
                </div>
            </div>
            `;

            $('.ecomsend__Modal__DescriptionText')
                .empty()
                .append(popupHTML);
            swapToEnglish('.newsletter-step-1-text', '.newsletter-step-1-text-eng');

            // Custom → Shopify (live)
            $(document).on('input', '.newsletter-custom-email', function () {
                const val = $(this).val();
                $('.field__input[name="contact[email]"]').val(val);
            });
            function syncShopifyToCustom() {
                const val = $('.field__input[name="contact[email]"]').val();
                $('.newsletter-custom-email').val(val);
            }


            setTimeout(doAfterLoad, 100);
            function doAfterLoad() {
                $('.newsletter-step-1').append($('.newsletter-form-1'));
            }

            syncShopifyToCustom();

            $('.newsletter-agree').click(function () {
                $('#Subscribe').trigger('click');
            });

        }, 1); // delay to allow modal to render
    }


    // ✅ 1. When user clicks the SendWILL widget
    $(document).on('click', '.ecomsend__Popover__Widget__left', function () {
        injectNewsletterPopup();
    });


    // Track if we've already injected into the current modal
    let swInjected = false;

    const swObserver = new MutationObserver(function () {

        const modalDesc = $('.ecomsend__Modal__DescriptionText');

        // If modal exists AND we haven't injected yet
        if (modalDesc.length && !swInjected) {
            swInjected = true; // prevent reinjection
            injectNewsletterPopup();
        }

        // Reset when modal closes
        if (!$('.ecomsend__Modal__DescriptionText').length) {
            swInjected = false;
        }

    });

    swObserver.observe(document.body, { childList: true, subtree: true });

});


jQuery(function ($) {
  var $video = $('.banner-video');

  $video.each(function () {
    var el = this;

    function showVideo() {
      $(el).addClass('video-visible');
    }

    // Fires when playback actually begins
    el.addEventListener('playing', showVideo, { once: true });

    // Fallback: if already playing before listener attaches
    if (!el.paused && !el.ended && el.readyState > 2) {
      showVideo();
    }
  });
});